import React from 'react';
import {RouteConfig} from 'react-router-config';
import {fieldsParametersIndexPath, selectedFieldWithService} from './configs/FieldsRoutePaths';

export const fieldsRouteConfigs: RouteConfig[] = [
  {
    auth: ['user'],
    routes: [
      {
        path: selectedFieldWithService,
        component: React.lazy(() => import('./components/Fields')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: fieldsParametersIndexPath,
        component: React.lazy(() => import('./components/fields_parameters/FieldsParameters')),
      },
    ],
  },
];
